var _rect, _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUkFlag = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_5622)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5V15.5H20V0.5H0Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_251_5622",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5V15.5H20V0.5H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_251_5622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.22693 14.4285L2.17413 16.2898L20.0999 2.52378L22.4214 -0.242144L17.7151 -0.864241L10.4036 5.06793L4.51856 9.06482L-2.22693 14.4285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.62439 15.7326L0.617745 16.8127L21.5878 -0.499094H18.4395L-1.62439 15.7326Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2271 14.4285L17.826 16.2898L-0.0997791 2.52378L-2.42124 -0.242144L2.28506 -0.864241L9.59656 5.06793L15.4816 9.06482L22.2271 14.4285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0769 15.3644L19.8348 16.4446L10.9055 9.03248L8.25819 8.20435L-2.64459 -0.232651H0.503632L11.4003 8.00409L14.2947 8.99711L22.0769 15.3644Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_251_5622",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3611 -0.75H7.63889V5.5H-1.23279V10.5H7.63889V16.75H12.3611V10.5H21.2672V5.5H12.3611V-0.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3611 -0.75H7.63889V5.5H-1.23279V10.5H7.63889V16.75H12.3611V10.5H21.2672V5.5H12.3611V-0.75Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63889 -0.75V-2H6.38889V-0.75H7.63889ZM12.3611 -0.75H13.6111V-2H12.3611V-0.75ZM7.63889 5.5V6.75H8.88889V5.5H7.63889ZM-1.23279 5.5V4.25H-2.48279V5.5H-1.23279ZM-1.23279 10.5H-2.48279V11.75H-1.23279V10.5ZM7.63889 10.5H8.88889V9.25H7.63889V10.5ZM7.63889 16.75H6.38889V18H7.63889V16.75ZM12.3611 16.75V18H13.6111V16.75H12.3611ZM12.3611 10.5V9.25H11.1111V10.5H12.3611ZM21.2672 10.5V11.75H22.5172V10.5H21.2672ZM21.2672 5.5H22.5172V4.25H21.2672V5.5ZM12.3611 5.5H11.1111V6.75H12.3611V5.5ZM7.63889 0.5H12.3611V-2H7.63889V0.5ZM8.88889 5.5V-0.75H6.38889V5.5H8.88889ZM-1.23279 6.75H7.63889V4.25H-1.23279V6.75ZM0.0172119 10.5V5.5H-2.48279V10.5H0.0172119ZM7.63889 9.25H-1.23279V11.75H7.63889V9.25ZM8.88889 16.75V10.5H6.38889V16.75H8.88889ZM12.3611 15.5H7.63889V18H12.3611V15.5ZM11.1111 10.5V16.75H13.6111V10.5H11.1111ZM21.2672 9.25H12.3611V11.75H21.2672V9.25ZM20.0172 5.5V10.5H22.5172V5.5H20.0172ZM12.3611 6.75H21.2672V4.25H12.3611V6.75ZM11.1111 -0.75V5.5H13.6111V-0.75H11.1111Z",
    fill: "white",
    mask: "url(#path-7-inside-1_251_5622)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_5622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUkFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/uk_flag.317c26556c40216681bff5f0f6d51e92.svg";